import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import type { Facet, FilterSelection } from '@fantaz/shared/data-access/models';

@Component({
  selector: 'fz-desktop-filters',
  templateUrl: './desktop-filters.html',
  styleUrls: ['./desktop-filters.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'fz-desktop-filters',
  },
})
export class DesktopFiltersComponent {
  facet = input.required<Facet>();
  filters = input<FilterSelection>({});
  filterChange = output<FilterSelection>();
  close = output<void>();
  clear = output<void>();

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth < 768) {
      this.close.emit();
    }
  }

  selectionChange(changes: FilterSelection) {
    this.filterChange.emit(changes);
  }
}
